// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"_3MCrB6QhgcOnrIyT-3gGjW"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/navigation/breadcrumbs.scss
// module id = 105
// module chunks = 0